import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import * as fromStore from '@app/auth/store';
import { Login } from '@app/auth/store/actions/auth.actions';
import { Authenticate } from '@app/auth/models/authentication.model';

@Component({
  selector: 'app-login-page',
  template: `
    <app-auth-wrapper>
      <div auth-form>
        <app-login-form (submitted)="onLogin($event)"></app-login-form>
      </div>
    </app-auth-wrapper>
  `
})
export class LoginPageComponent implements OnInit {
  error$ = this.store.select(fromStore.selectLoginPageError);
  pending$ = this.store.select(fromStore.selectLoginPagePending);

  constructor(private store: Store<fromStore.State>) {}

  ngOnInit() {}

  onLogin(credentials: Authenticate) {
    this.store.dispatch(new Login(credentials));
  }
}
